import { cn } from '@/platform/lib/utils';
import {
    ChevronDownIcon,
    ChevronUpDownIcon,
    ChevronUpIcon,
} from '@heroicons/react/20/solid';
import { forwardRef } from 'react';

const alignments = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
};

const sortDirections = {
    ASC: 'ascending',
    DESC: 'descending',
};

const TableHeaderCell = forwardRef(function TableHeaderCell(
    {
        textAlign,
        sorted,
        collapsing = false,
        onClick,
        className,
        children,
        ...props
    },
    ref
) {
    // A sortable header always receives `sorted` (null when unsorted). Do not
    // infer it from `onClick`: a TooltipTrigger with `asChild` injects one.
    const sortable = sorted !== undefined;

    return (
        <th
            ref={ref}
            onClick={onClick}
            aria-sort={
                sortable ? (sortDirections[sorted] ?? 'none') : undefined
            }
            className={cn(
                'px-3 py-2.5 whitespace-nowrap select-none first:pl-4 last:pr-4',
                alignments[textAlign],
                collapsing && 'w-px',
                sortable &&
                    'cursor-pointer transition-colors hover:bg-gray-100',
                className
            )}
            {...props}
        >
            <span className='inline-flex items-center gap-1'>
                {children}
                {sortable &&
                    (sorted === 'ASC' ? (
                        <ChevronUpIcon className='size-3.5 text-gray-600' />
                    ) : sorted === 'DESC' ? (
                        <ChevronDownIcon className='size-3.5 text-gray-600' />
                    ) : (
                        <ChevronUpDownIcon className='size-3.5 text-gray-300' />
                    ))}
            </span>
        </th>
    );
});

export default TableHeaderCell;
